<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';

defineOptions({
	name: 'ButtonRetry',
});

const {
	color = 'neutral',
	variant = 'outline',
	size = 'sm',
	// Otherwise both are set to `false` and NuxtLink will detect a conflict
	// eslint-disable-next-line unicorn/no-useless-undefined -- without a default, Vue casts an absent Boolean prop to false
	prefetch = undefined,
	// eslint-disable-next-line unicorn/no-useless-undefined -- without a default, Vue casts an absent Boolean prop to false
	noPrefetch = undefined,
	...forwardedProps
} = defineProps<ButtonProps>();
</script>

<template>
	<!-- Undeclared attributes reach `DButton` on their own, so only props are forwarded here.
		`label` goes last so it wins over the `undefined` the spread carries. -->
	<DButton
		v-bind="{ ...forwardedProps, color, variant, size, prefetch, noPrefetch }"
		:label="label ?? $t('common.retry')"
	>
		<slot />
	</DButton>
</template>
